import { isQuotingToolAvailable } from 'modules/common/permissions';

import DashboardDetailsPage from './dashboardEntry';
import { initAdvancedAnalytics, initExplorePage } from './data/sagas';
import ExplorePage from './exploreEntry';

export default [
  {
    component: DashboardDetailsPage,
    exact: true,
    path: '/analytics/dashboards',
    permissions: [isQuotingToolAvailable],
    saga: initAdvancedAnalytics,
  },
  {
    component: ExplorePage,
    path: '/analytics/explore/',
    exact: true,
    permissions: [isQuotingToolAvailable],
    saga: initExplorePage,
  },
  {
    component: ExplorePage,
    path: '/analytics/explore/:queryId',
    exact: true,
    permissions: [isQuotingToolAvailable],
    saga: initExplorePage,
  },
];
